import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { CommonIcons } from "@42maru/webchat";
import { useUploadedFiles } from "@/hook";
import { ImageUploadBtn } from "@/component/input";
import Tooltip from "@/component/Tooltip";
import ClickableImg from "@/component/ClickableImg";
import { DeleteIcon } from "@/assets/svgs/icons";

import { WebchatThemeFormProps } from ".";
import { WebchatRadioGroup, WebchatRadioGroupOption } from "../component";


const AVATAR_SHAPE_OPTIONS: WebchatRadioGroupOption<"round" | "square">[] = [
    { value: "round", labelKey: "b0026" },
    { value: "square", labelKey: "b0027" }
];

const AvatarInputGroup: React.FC<WebchatThemeFormProps> = (props) => {
    const { theme, legend, onChange } = props;

    const intl = useIntl();
    const { add, remove } = useUploadedFiles();

    const onUploadAvatar = async (file: File, url: string) => {
        if (theme.avatarUrl) {
            remove(theme.avatarUrl);
        }
        add(file, url);
        onChange({ ...theme, avatarUrl: url, titleImageUrl: undefined });
    };

    const onDeleteAvatar = () => {
        const url = theme.avatarUrl;
        if (url) {
            remove(url);
        }
        onChange({ ...theme, avatarUrl: undefined });
    };

    const avatarShapeSelection = useMemo(() => {
        if (theme.roundAvatar === undefined) {
            return "round";
        }
        return theme.roundAvatar ? "round" : "square";
    }, [theme.roundAvatar]);

    return (
        <fieldset className="webchat-setting-card-grid">
            <legend className="sr-only">
                {legend}
            </legend>
            <div className="flex gap-1 items-center">
                <div className="label-input-grid-label field-label">
                    {intl.formatMessage({ id: "b0052" })}
                </div>
                <Tooltip message={intl.formatMessage({ id: "i09021" })} />
            </div>
            <div className="h-input-default flex items-center gap-4">
                {theme.avatarUrl ? (<>
                    <ClickableImg src={theme.avatarUrl}
                                  alt={intl.formatMessage({ id: "b0052" })}
                                  height={24}
                                  width={24}
                    />
                    <button aria-label={intl.formatMessage({ id: "b0006" })}
                            onClick={onDeleteAvatar}
                    >
                        <DeleteIcon className="text-point-red size-4" />
                    </button>
                </>) : (<>
                    <div className="size-[36px] flex items-center justify-center rounded-full overflow-hidden">
                        {CommonIcons.defaultBotLogo(24)}
                    </div>
                    <ImageUploadBtn onUpload={onUploadAvatar} />
                </>)}
            </div>

            <div id="webchat-avatar-shape"
                 className="label-input-grid-label field-label">
                {intl.formatMessage({ id: "b0053" })}
            </div>
            <WebchatRadioGroup name="webchat-avatar-shape"
                               aria-labelledby="webchat-avatar-shape"
                               options={AVATAR_SHAPE_OPTIONS}
                               selectedValue={avatarShapeSelection}
                               onChange={v => onChange({ ...theme, roundAvatar: v === "round" })}
            />
        </fieldset>
    );
};

export default AvatarInputGroup;
